module.exports = __webpack_public_path__ + "static/img/GF.b747d0a3.svg";